import type { Testimonial } from '../components/Testimonials'

/**
 * ⚠️ SAMPLE COPY — NOT REAL CUSTOMERS.
 *
 * These three entries exist so the section can be seen and approved. They must
 * be replaced with real, attributed quotes from the 15-copy beta before any
 * paid traffic runs: publishing invented testimonials is an FTC violation and,
 * in the wedding market, the fastest way to get named in a forum thread.
 *
 * When a reviewer received a free copy, set `disclosure` to
 * 'Early reader — received a free copy.'
 *
 * Slot guide, pre-price:
 *  1. Economic result with a number (a budget line caught in time).
 *  2. Chaos or crisis resolved — ideally naming a specific month.
 *  3. Status / relationship change (the couple, the family, the engagement).
 */
export const preTestimonials: Testimonial[] = [
  {
    quote:
      'The catering service fee was sitting right there in Volume One, and we caught it before we signed. That one page saved us just over $1,400.',
    author: 'Hannah M.',
    role: 'Austin, TX',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/715ea526-30f1-4766-971f-357f206b3b1b.jpg',
    disclosure: 'Early reader — received a free copy.',
  },
  {
    quote:
      'Month seven was where I always fell apart. I opened Volume Three, did the three things it told me to do, and closed it. First week in months I didn’t feel behind.',
    author: 'Amara O.',
    role: 'Manchester, UK',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/74c6a619-de21-4473-a0b0-e728fed7948b.jpg',
    disclosure: 'Early reader — received a free copy.',
  },
  {
    quote:
      'We stopped fighting about the wedding on Sundays. Twenty minutes, the volume for that month, done — and we got the rest of our engagement back.',
    author: 'Grace T.',
    role: 'Melbourne, AU',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/a0e7d7b2-9e98-47c7-9eac-90aa875ff6e5.jpg',
    disclosure: 'Early reader — received a free copy.',
  },
]

/**
 * Post-price slots. Each quote should name a specific component —
 * Volume 1, The Vendor Booking Order, Volume 5, the Deadline Calendar —
 * to make the pricing card's list tangible. Real quotes only.
 */
export const postTestimonials: Testimonial[] = []
